import { render } from "./typeModal.vue?vue&type=template&id=26b7e26a&scoped=true"
import script from "./typeModal.vue?vue&type=script&lang=js"
export * from "./typeModal.vue?vue&type=script&lang=js"

import "./typeModal.vue?vue&type=style&index=0&id=26b7e26a&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b7e26a"]])

export default __exports__